<div class="h-100 d-flex flex-column" appNoBackNav>
  <div class="px-4 py-3 d-flex justify-content-between align-items-center gap-3" [style.background-color]="orgLogo.BrandColor || '#1D5558'" >
    <img [src]="orgLogo.LogoBase64 || '../Images/ehnote-logo.svg'" alt="Organization Logo" style="max-width: 150px; max-height: 50px;">
    <app-language-switch idPrefix="pl"></app-language-switch>
  </div>

  <div class="position-relative h-100">
    <div class="container-fluid slim__scroll-- adjustable__position-- bg__FFFFFF--">
      <div class="row h-100">
        <!-- Left Section -->
        <div class="col-12 col-lg-6">
          <div
            class="bg__FFFEFE-- login__background-- d-flex flex-column justify-content-between align-items-center text-left text-lg-start text-white p-4 px-md-5 py-md-4 h-100">
            <div class="w-100">
              <h2 class="mb-3 mt-md-5 mt-sm-0 fw__7-- fs__40-- tc__006080--">{{ (orgLogo.PracticeName || 'Experience Clarity') | translate }}</h2>
              <p class="mb-3 fw__5-- fs__22-- tc__006080-- lh__33--px">
                {{ (orgLogo.Subtext || 'Sign in to manage your visits and care details with EHNOTE.') | translate }}
              </p>
            </div>
            <div class="w-100 d-none d-lg-block">
              <p class="d-flex align-items-center text-center gap-2 m-0">
                <span class="mb-0 fw__5-- fs__13-- tc__006080--">{{ 'POWERED BY' | translate }}</span>
                <svg  width="79" height="18" viewBox="0 0 79 18" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.9997 4.2489C17.9997 4.19205 17.9997 4.13426 17.9997 4.0774C17.9941 3.81548 17.968 3.55542 17.9205 3.29723C17.6502 1.85435 16.568 0.624918 15.1251 0.185901C14.7057 0.0572721 14.2788 0.000414265 13.8416 0.000414265C10.624 0.000414265 7.40643 0.000414265 4.18884 0.000414265C4.13198 0.000414265 4.07419 -0.000517831 4.01733 0.000414265C3.72186 0.00880312 3.42918 0.0395623 3.14209 0.109469C2.1839 0.343425 1.40187 0.850485 0.809059 1.63997C0.330894 2.27845 0.0624504 2.99803 0.0139814 3.79591C0.00466048 3.94318 0.000932095 4.09045 0.000932095 4.23772C0 7.4143 0 10.5909 0 13.7675C0 13.8243 0 13.8821 0 13.939C0.00559257 14.226 0.0260987 14.5122 0.0894811 14.7918C0.310388 15.7621 0.809991 16.5582 1.60134 17.164C2.24821 17.6599 2.98084 17.9377 3.79736 17.9852C3.95208 17.9945 4.10774 17.9992 4.2634 17.9992C5.8433 18.0001 7.42321 17.9992 9.00404 17.9992C10.4609 17.9992 11.9187 17.9992 13.3756 17.9992C13.5396 17.9992 13.7027 18.001 13.8668 17.9992C14.1697 17.9954 14.4726 17.9796 14.77 17.9134C15.6704 17.713 16.4272 17.2684 17.0257 16.5656C17.5653 15.9309 17.8813 15.1973 17.9699 14.3668C17.9913 14.1627 17.9997 13.9585 17.9997 13.7544C17.9997 10.5862 17.9997 7.41803 17.9997 4.2489ZM13.8817 9.0986C13.425 9.54507 12.7501 9.51804 12.327 9.06411C11.8814 8.58594 11.9187 7.84399 12.3764 7.40591C12.7809 7.01909 13.4147 7.00884 13.8267 7.37329C14.0933 7.60911 14.2219 7.90738 14.2284 8.2448C14.2238 8.58687 14.1147 8.87116 13.8808 9.0986H13.8817Z"
                    fill="#1D5558" />
                  <path
                    d="M14.8286 7.88062C14.7447 7.48355 14.5555 7.14613 14.2507 6.87769C13.8965 6.56544 13.479 6.41351 13.0083 6.44986C12.463 6.49273 12.0286 6.74813 11.7136 7.19647C11.2839 7.80699 11.2568 8.6496 11.6875 9.3002C11.9065 9.6311 12.2039 9.86692 12.5814 9.99648C12.6662 10.0254 12.7547 10.044 12.8414 10.0673C12.8722 10.0757 12.9057 10.0776 12.9337 10.1288C12.9411 10.1661 12.9402 10.223 12.9402 10.2798C12.9402 10.5007 12.9393 10.7216 12.9402 10.9426C12.9411 11.115 12.9318 11.2856 12.9122 11.4571C12.8545 11.98 12.6792 12.4609 12.3754 12.8897C11.8562 13.6223 11.1571 14.0585 10.2567 14.1648C9.82515 14.2161 9.40571 14.1648 9.00118 14.0194C8.09798 13.6932 7.49492 13.0621 7.15843 12.1701C7.027 11.8225 6.97201 11.458 6.96735 11.088C6.96362 10.8428 6.96735 10.5967 6.96735 10.3516C6.96735 10.0981 6.96735 9.84362 6.96735 9.59009C6.96735 9.54162 6.95989 9.49128 6.99904 9.43722C7.06056 9.42324 7.1314 9.40273 7.20317 9.39155C7.4306 9.35613 7.65057 9.29461 7.86309 9.20699C8.92009 8.76798 9.60518 7.98968 9.95285 6.90658C10.0712 6.53748 10.1141 6.15625 10.1122 5.7685C10.1094 5.03214 10.1122 4.29486 10.1113 3.5585C10.1113 3.50164 10.1113 3.44385 10.1066 3.387C10.0983 3.25091 9.97895 3.14186 9.84659 3.14186C9.68254 3.14186 9.51942 3.14092 9.35538 3.14092C9.26496 3.14092 9.17548 3.13906 9.08507 3.14465C8.97601 3.15211 8.90611 3.21549 8.86416 3.31336C8.83806 3.37488 8.8334 3.44013 8.83806 3.5063C8.84925 3.69459 8.95644 3.79805 9.13074 3.80085C9.22022 3.80271 9.31064 3.80551 9.40012 3.81017C9.43088 3.8111 9.46257 3.84372 9.46536 3.87355C9.46816 3.89778 9.47096 3.92202 9.47096 3.94625C9.47096 4.10191 9.47096 4.25757 9.47096 4.41323C9.47096 4.91283 9.47748 5.41244 9.46816 5.91111C9.45325 6.65306 9.19133 7.30273 8.69266 7.8508C8.14738 8.45013 7.46043 8.75959 6.65137 8.7801C6.23752 8.79035 5.83951 8.69807 5.46202 8.52377C4.54204 8.09967 3.80195 7.14334 3.77026 5.89899C3.75349 5.25305 3.76747 4.60524 3.76747 3.9593C3.76747 3.92668 3.77213 3.89406 3.77679 3.86236C3.78052 3.8344 3.80475 3.82042 3.82712 3.81576C3.8672 3.80737 3.90821 3.80551 3.94829 3.80364C4.02193 3.79991 4.09556 3.80271 4.1692 3.79525C4.28758 3.78314 4.38172 3.68806 4.3957 3.57155C4.40129 3.52308 4.39943 3.47368 4.40036 3.42428C4.40222 3.26676 4.27639 3.13999 4.12353 3.14186C3.90262 3.14465 3.68171 3.14186 3.46081 3.14186C3.42818 3.14186 3.39556 3.14372 3.36294 3.14652C3.30235 3.15118 3.25482 3.18194 3.2138 3.22295C3.16627 3.27142 3.1383 3.33014 3.13271 3.39725C3.12805 3.45411 3.12898 3.5119 3.12898 3.56875C3.12898 4.29765 3.12898 5.02562 3.12898 5.75452C3.12898 5.93441 3.1411 6.11337 3.16254 6.29327C3.23338 6.86371 3.42166 7.39221 3.7423 7.86757C4.30529 8.7018 5.0752 9.22564 6.0744 9.39714C6.14524 9.40926 6.22074 9.41299 6.28785 9.45493C6.31488 9.52484 6.30556 9.59941 6.30556 9.67211C6.30556 10.1055 6.30556 10.5399 6.30556 10.9733C6.30556 11.0712 6.30743 11.17 6.30929 11.2679C6.32048 11.7143 6.41834 12.144 6.58519 12.5569C7.11462 13.8675 8.29745 14.725 9.56323 14.8583C10.0013 14.904 10.4301 14.8732 10.8523 14.7613C11.6213 14.5581 12.2542 14.1387 12.751 13.5207C13.2916 12.8478 13.574 12.076 13.5955 11.2119C13.6029 10.909 13.5973 10.6061 13.5983 10.3031C13.5983 10.2295 13.6001 10.1559 13.602 10.0822C13.6029 10.0459 13.6262 10.0216 13.6561 10.0077C13.7073 9.9825 13.7605 9.96106 13.8127 9.93776C14.1352 9.79235 14.3915 9.56958 14.5788 9.27038C14.8454 8.84161 14.9321 8.37836 14.8277 7.88156L14.8286 7.88062Z"
                    fill="white" stroke="white" stroke-width="0.5" />
                  <path
                    d="M13.8854 9.09869C13.671 9.30748 13.4091 9.41281 13.1472 9.41934C13.1295 9.41934 13.1127 9.41934 13.095 9.41934C13.0605 9.4184 13.0251 9.41561 12.9906 9.41095C12.9561 9.40629 12.9216 9.40069 12.8871 9.3923C12.8704 9.38858 12.8526 9.38392 12.8359 9.37926C12.8144 9.37273 12.793 9.36621 12.7725 9.35875C12.7436 9.3485 12.7156 9.33731 12.6867 9.32426C12.6541 9.30935 12.6224 9.29257 12.5907 9.27486C12.5749 9.26554 12.56 9.25622 12.5441 9.24597C12.4677 9.19656 12.3959 9.13598 12.3307 9.06607C12.1219 8.84237 12.0194 8.56088 12.0156 8.28032C12.0156 8.28032 12.0156 8.27938 12.0156 8.27845C12.0156 8.25981 12.0156 8.24117 12.0156 8.22253C12.0268 7.92239 12.1508 7.62785 12.3801 7.40787C12.4686 7.32305 12.5684 7.25688 12.6737 7.20747C12.7035 7.19349 12.7343 7.18138 12.766 7.17019C12.875 7.13197 12.9887 7.11147 13.1024 7.1096C13.1509 7.10867 13.2003 7.11054 13.2488 7.11613C13.2814 7.11986 13.3131 7.12545 13.3457 7.13197C13.521 7.16833 13.6887 7.24942 13.8304 7.37432C13.9246 7.45728 14.0001 7.54769 14.0606 7.64556C14.0793 7.67539 14.0961 7.70521 14.111 7.73597C14.1222 7.75834 14.1324 7.78164 14.1417 7.80402C14.1986 7.94103 14.2284 8.08924 14.2312 8.2449C14.2266 8.58697 14.1175 8.87126 13.8835 9.09869H13.8854Z"
                    fill="#1D5558" />
                  <path
                    d="M22.5 3.85938H28.7227C29.0051 3.85938 29.1458 4.00571 29.1458 4.29653V6.17283H28.4123L28.3135 4.63488H24.504V8.54315H28.5111V9.31958H24.504V13.3975H28.4402L28.553 11.9015H29.2866V13.7219C29.2866 14.0136 29.1402 14.159 28.8494 14.159H22.5V13.4255L23.3752 13.3267V4.70572L22.5 4.59293V3.85938Z"
                    fill="#1D5558" />
                  <path
                    d="M40.2111 14.159H38.6452C38.3535 14.159 38.2081 14.0136 38.2081 13.7219V9.44635H33.3546V13.7219C33.3546 14.0136 33.2083 14.159 32.9175 14.159H31.3516V13.4255L32.2268 13.3127V4.70572L31.3516 4.59293V3.85938H32.9175C33.2092 3.85938 33.3546 4.00571 33.3546 4.29653V8.57204H38.2081V4.29653C38.2081 4.00478 38.3535 3.85938 38.6452 3.85938H40.2111V4.59293L39.3359 4.67775V13.3127L40.2111 13.4255V14.159Z"
                    fill="#1D5558" />
                  <path
                    d="M50.6796 14.159H49.7484C49.5033 14.159 49.3299 14.0649 49.2265 13.8766L44.2882 5.65086V13.7219C44.2882 14.0136 44.1419 14.159 43.8511 14.159H42.2852V13.4255L43.1604 13.3267V4.70572L42.2852 4.59293V3.85938H44.0916C44.3171 3.85938 44.4914 3.95352 44.6135 4.1418L49.5518 12.3815V4.29653C49.5518 4.00478 49.6925 3.85938 49.9749 3.85938H51.5548V4.59293L50.6796 4.70572V14.159Z"
                    fill="#1D5558" />
                  <path
                    d="M53.1445 9.00368C53.1445 7.29142 53.509 5.97251 54.2379 5.046C54.9668 4.1195 55.9734 3.65625 57.2569 3.65625C58.5404 3.65625 59.5499 4.1195 60.2834 5.046C61.017 5.97251 61.3843 7.29142 61.3843 9.00368C61.3843 10.7159 61.017 12.0349 60.2834 12.9614C59.5499 13.8879 58.5414 14.3511 57.2569 14.3511C55.9725 14.3511 54.9668 13.8879 54.2379 12.9614C53.509 12.0349 53.1445 10.7159 53.1445 9.00368ZM60.2555 9.00368C60.2555 7.56452 59.9898 6.4572 59.4585 5.68076C58.9272 4.90433 58.1937 4.51657 57.2579 4.51657C56.322 4.51657 55.5885 4.90433 55.0572 5.68076C54.5259 6.4572 54.2603 7.56452 54.2603 9.00368C54.2603 10.4428 54.5259 11.5502 55.0572 12.3266C55.5885 13.103 56.322 13.4908 57.2579 13.4908C58.1937 13.4908 58.9272 13.103 59.4585 12.3266C59.9898 11.5502 60.2555 10.4428 60.2555 9.00368Z"
                    fill="#1D5558" />
                  <path
                    d="M63.1217 3.85249H69.5839C69.8756 3.85249 70.0211 3.99883 70.0211 4.28965V6.20883H69.2875L69.1747 4.62893H66.9172V13.3207L68.1867 13.4195V14.1531H64.518V13.4195L65.7875 13.3207V4.628H63.5299L63.4172 6.2079H62.6836V4.28872C62.6836 3.99697 62.829 3.85156 63.1207 3.85156L63.1217 3.85249Z"
                    fill="#1D5558" />
                  <path
                    d="M71.3203 3.85938H77.543C77.8254 3.85938 77.9662 4.00571 77.9662 4.29653V6.17283H77.2326L77.1338 4.63488H73.3243V8.54315H77.3314V9.31958H73.3243V13.3975H77.2606L77.3733 11.9015H78.1069V13.7219C78.1069 14.0136 77.9606 14.159 77.6697 14.159H71.3203V13.4255L72.1956 13.3267V4.70572L71.3203 4.59293V3.85938Z"
                    fill="#1D5558" />
                </svg>
              </p>
            </div>
          </div>
        </div>

        <!-- Login Section -->
        @if (activeTab === 1) {
        <div class="col-12 col-lg-6 position-relative">
          @if(isOtpLoading) {
            <div class="login__form--overlay">
              <div class="login__form--spinner"></div>
            </div>
          }
          <div class="d-flex flex-column justify-content-center align-items-center px-4 pt-4 pb-4 h-100" [style.pointer-events]="isOtpLoading ? 'none' : 'auto'">
            <div class="w-100 h-100 d-flex flex-column justify-content-center" style="max-width:380px;">
              <h4 class="fs__30-- fw__6-- tc__101828-- lh__38--px mb-4 text-start">{{ 'Log in to your account' | translate }}</h4>
              <form name="myForm" [formGroup]="credentials" (ngSubmit)="nextTab('validateCredentials')" novalidate
                autocomplete="off">
                <div class="input__style--1 mb-3"
                  [class.has-error]="(hasUserName && credentials.controls.userName.invalid) || ((userNameNotExist || credentialsNotValid) && credentials.controls.userName.valid)">
                  <label for="pl__username" class="mb-1">{{ 'Username' | translate }} <span class="text-danger">*</span></label>
                  <input type="text" id="pl__username" formControlName="userName"
                    [placeholder]="'Enter Username' | translate" >
                  @if(hasUserName && credentials.controls.userName.invalid){
                  <small class="text-danger">{{ 'Username is required' | translate }}</small>
                  }
                  @if(userNameNotExist && credentials.controls.userName.valid){
                  <small class="text-danger">{{ 'No record found for the entered username.' | translate }}</small>
                  }
                  @if(credentialsNotValid && credentials.controls.userName.valid){
                  <small class="text-danger">{{ 'Credentials are not valid.' | translate }}</small>
                  }
                </div>
                <div class="input__style--1 mb-3 position-relative"
                  [class.has-error]="(hasUserName && credentials.controls.password.invalid) || (credentialsNotValid && credentials.controls.password.valid)">
                  <div class="d-flex justify-content-between align-items-center">
                    <label for="pl__password" class="mb-1">{{ 'Password' | translate }} <span class="text-danger">*</span></label>
                    <a (click)="nextTab('loginWithOtp')"
                      class="fs__13-- fw__6-- lh__20--px c__p-- text-decoration-none tc__006080--" 
                      id="pl__loginwithotp">
                      {{ 'Login with OTP' | translate }}
                    </a>
                  </div>
                  <input [type]="showPassword ? 'text' : 'password'" id="pl__password" formControlName="password"
                    [placeholder]="'Enter password' | translate" maxlength="15" >
                  @if(hasUserName && credentials.controls.password.invalid){
                  <small class="text-danger">{{ 'Password is required' | translate }}</small>
                  }
                  @if(credentialsNotValid && credentials.controls.password.valid){
                  <small class="text-danger">{{ 'Credentials are not valid.' | translate }}</small>
                  }
                  <div class="position-absolute c__p-- tu__44--px ru__26--px">
                    <!-- Show icon -->
                    @if(!showPassword){
                    <svg id="pl__passwordshow" class="icon__16--" (click)="togglePassword()">
                      <use href="../Images/icons__sprite.svg#icon__passwordshow"></use>
                    </svg>
                    }
                    <!-- Hide icon -->
                    @if (showPassword) {
                    <svg id="pl__passwordhide" class="icon__16--" (click)="togglePassword()">
                      <use href="../Images/icons__sprite.svg#icon__passwordhide"></use>
                    </svg>
                    }
                  </div>
                </div>

                <div class="d-flex justify-content-end mb-3">
                  <a (click)="nextTab('forgotPassword')"
                    class="fs__13-- fw__6-- lh__20--px c__p-- text-decoration-none tc__006080--" 
                    id="pl__forgotpassword">
                    {{ 'Forgot Password?' | translate }}
                  </a>
                </div>
                @if(noContactAvailable) {
                <p class="mb-0 fw__4-- fs__14-- text-danger mt-1">
                  {{ 'We couldn\'t find an email or mobile number linked to your account. Please contact your administrator for assistance.' | translate }}
                </p>
                }
                <button type="submit" [disabled]="isOtpLoading" class="btn__l-- btn__006080--f mb-3" 
                  id="pl__login">{{ 'Login' | translate }}
                  <!-- <ng-container *ngIf="!isOtpLoading; else loading"></ng-container>
                  <ng-template #loading>
                    <div class="spinner"></div>
                  </ng-template> -->
                </button>

                <div class="text-center">
                  <span class="fw__4-- fs__14-- tc__475467--">
                    {{ 'Don’t have an account?' | translate }}
                    <a class="fw__6-- fs__14-- tc__006080-- text-decoration-none" (click)="nextTab('signUp')" 
                      id="a__signup">{{ 'Sign up' | translate }}</a>
                  </span>
                </div>
              </form>
            </div>

            <div class="row mt-4">
              <div class="col-lg-12">
                <div class="row justify-content-center align-items-center text-center text-md-start flex-md-row mt-3">

                  <div class="col-auto mb-2 mb-md-0" >
                    <p class="mb-0 fw__6-- fs__13-- tc__1D1D1D--">© {{currentYear}} EHNOTE Care</p>
                  </div>

                  <div class="col-auto">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item" >
                        <a id="pl__privacy" class="text-decoration-none fw__6-- fs__13-- tc__006080--"
                          href="https://www.ehnote.com/ehr/Privacy-Policy.html" target="_blank">
                          {{ 'Privacy Policy' | translate }}
                        </a>
                      </li>
                      <li class="list-inline-item">
                        <p class="fw__5-- fs__13-- tc__1D1D1D-- d-inline">{{ 'and' | translate }}</p>
                      </li>
                      <li class="list-inline-item" >
                        <a id="pl__terms" class="text-decoration-none fw__5-- fs__13-- tc__006080--"
                          href="https://www.ehnote.com/ehr/TermsOfService.html" target="_blank">
                          {{ 'Terms of Services' | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100 d-block d-lg-none mt-3">
              <p class="d-flex justify-content-center align-items-center text-center gap-2">
                <span class="fw__5-- fs__13-- tc__006080--">{{ 'POWERED BY' | translate }}</span>
                <svg width="79" height="18" viewBox="0 0 79 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.9997 4.2489C17.9997 4.19205 17.9997 4.13426 17.9997 4.0774C17.9941 3.81548 17.968 3.55542 17.9205 3.29723C17.6502 1.85435 16.568 0.624918 15.1251 0.185901C14.7057 0.0572721 14.2788 0.000414265 13.8416 0.000414265C10.624 0.000414265 7.40643 0.000414265 4.18884 0.000414265C4.13198 0.000414265 4.07419 -0.000517831 4.01733 0.000414265C3.72186 0.00880312 3.42918 0.0395623 3.14209 0.109469C2.1839 0.343425 1.40187 0.850485 0.809059 1.63997C0.330894 2.27845 0.0624504 2.99803 0.0139814 3.79591C0.00466048 3.94318 0.000932095 4.09045 0.000932095 4.23772C0 7.4143 0 10.5909 0 13.7675C0 13.8243 0 13.8821 0 13.939C0.00559257 14.226 0.0260987 14.5122 0.0894811 14.7918C0.310388 15.7621 0.809991 16.5582 1.60134 17.164C2.24821 17.6599 2.98084 17.9377 3.79736 17.9852C3.95208 17.9945 4.10774 17.9992 4.2634 17.9992C5.8433 18.0001 7.42321 17.9992 9.00404 17.9992C10.4609 17.9992 11.9187 17.9992 13.3756 17.9992C13.5396 17.9992 13.7027 18.001 13.8668 17.9992C14.1697 17.9954 14.4726 17.9796 14.77 17.9134C15.6704 17.713 16.4272 17.2684 17.0257 16.5656C17.5653 15.9309 17.8813 15.1973 17.9699 14.3668C17.9913 14.1627 17.9997 13.9585 17.9997 13.7544C17.9997 10.5862 17.9997 7.41803 17.9997 4.2489ZM13.8817 9.0986C13.425 9.54507 12.7501 9.51804 12.327 9.06411C11.8814 8.58594 11.9187 7.84399 12.3764 7.40591C12.7809 7.01909 13.4147 7.00884 13.8267 7.37329C14.0933 7.60911 14.2219 7.90738 14.2284 8.2448C14.2238 8.58687 14.1147 8.87116 13.8808 9.0986H13.8817Z"
                    fill="#1D5558" />
                  <path
                    d="M14.8286 7.88062C14.7447 7.48355 14.5555 7.14613 14.2507 6.87769C13.8965 6.56544 13.479 6.41351 13.0083 6.44986C12.463 6.49273 12.0286 6.74813 11.7136 7.19647C11.2839 7.80699 11.2568 8.6496 11.6875 9.3002C11.9065 9.6311 12.2039 9.86692 12.5814 9.99648C12.6662 10.0254 12.7547 10.044 12.8414 10.0673C12.8722 10.0757 12.9057 10.0776 12.9337 10.1288C12.9411 10.1661 12.9402 10.223 12.9402 10.2798C12.9402 10.5007 12.9393 10.7216 12.9402 10.9426C12.9411 11.115 12.9318 11.2856 12.9122 11.4571C12.8545 11.98 12.6792 12.4609 12.3754 12.8897C11.8562 13.6223 11.1571 14.0585 10.2567 14.1648C9.82515 14.2161 9.40571 14.1648 9.00118 14.0194C8.09798 13.6932 7.49492 13.0621 7.15843 12.1701C7.027 11.8225 6.97201 11.458 6.96735 11.088C6.96362 10.8428 6.96735 10.5967 6.96735 10.3516C6.96735 10.0981 6.96735 9.84362 6.96735 9.59009C6.96735 9.54162 6.95989 9.49128 6.99904 9.43722C7.06056 9.42324 7.1314 9.40273 7.20317 9.39155C7.4306 9.35613 7.65057 9.29461 7.86309 9.20699C8.92009 8.76798 9.60518 7.98968 9.95285 6.90658C10.0712 6.53748 10.1141 6.15625 10.1122 5.7685C10.1094 5.03214 10.1122 4.29486 10.1113 3.5585C10.1113 3.50164 10.1113 3.44385 10.1066 3.387C10.0983 3.25091 9.97895 3.14186 9.84659 3.14186C9.68254 3.14186 9.51942 3.14092 9.35538 3.14092C9.26496 3.14092 9.17548 3.13906 9.08507 3.14465C8.97601 3.15211 8.90611 3.21549 8.86416 3.31336C8.83806 3.37488 8.8334 3.44013 8.83806 3.5063C8.84925 3.69459 8.95644 3.79805 9.13074 3.80085C9.22022 3.80271 9.31064 3.80551 9.40012 3.81017C9.43088 3.8111 9.46257 3.84372 9.46536 3.87355C9.46816 3.89778 9.47096 3.92202 9.47096 3.94625C9.47096 4.10191 9.47096 4.25757 9.47096 4.41323C9.47096 4.91283 9.47748 5.41244 9.46816 5.91111C9.45325 6.65306 9.19133 7.30273 8.69266 7.8508C8.14738 8.45013 7.46043 8.75959 6.65137 8.7801C6.23752 8.79035 5.83951 8.69807 5.46202 8.52377C4.54204 8.09967 3.80195 7.14334 3.77026 5.89899C3.75349 5.25305 3.76747 4.60524 3.76747 3.9593C3.76747 3.92668 3.77213 3.89406 3.77679 3.86236C3.78052 3.8344 3.80475 3.82042 3.82712 3.81576C3.8672 3.80737 3.90821 3.80551 3.94829 3.80364C4.02193 3.79991 4.09556 3.80271 4.1692 3.79525C4.28758 3.78314 4.38172 3.68806 4.3957 3.57155C4.40129 3.52308 4.39943 3.47368 4.40036 3.42428C4.40222 3.26676 4.27639 3.13999 4.12353 3.14186C3.90262 3.14465 3.68171 3.14186 3.46081 3.14186C3.42818 3.14186 3.39556 3.14372 3.36294 3.14652C3.30235 3.15118 3.25482 3.18194 3.2138 3.22295C3.16627 3.27142 3.1383 3.33014 3.13271 3.39725C3.12805 3.45411 3.12898 3.5119 3.12898 3.56875C3.12898 4.29765 3.12898 5.02562 3.12898 5.75452C3.12898 5.93441 3.1411 6.11337 3.16254 6.29327C3.23338 6.86371 3.42166 7.39221 3.7423 7.86757C4.30529 8.7018 5.0752 9.22564 6.0744 9.39714C6.14524 9.40926 6.22074 9.41299 6.28785 9.45493C6.31488 9.52484 6.30556 9.59941 6.30556 9.67211C6.30556 10.1055 6.30556 10.5399 6.30556 10.9733C6.30556 11.0712 6.30743 11.17 6.30929 11.2679C6.32048 11.7143 6.41834 12.144 6.58519 12.5569C7.11462 13.8675 8.29745 14.725 9.56323 14.8583C10.0013 14.904 10.4301 14.8732 10.8523 14.7613C11.6213 14.5581 12.2542 14.1387 12.751 13.5207C13.2916 12.8478 13.574 12.076 13.5955 11.2119C13.6029 10.909 13.5973 10.6061 13.5983 10.3031C13.5983 10.2295 13.6001 10.1559 13.602 10.0822C13.6029 10.0459 13.6262 10.0216 13.6561 10.0077C13.7073 9.9825 13.7605 9.96106 13.8127 9.93776C14.1352 9.79235 14.3915 9.56958 14.5788 9.27038C14.8454 8.84161 14.9321 8.37836 14.8277 7.88156L14.8286 7.88062Z"
                    fill="white" stroke="white" stroke-width="0.5" />
                  <path
                    d="M13.8854 9.09869C13.671 9.30748 13.4091 9.41281 13.1472 9.41934C13.1295 9.41934 13.1127 9.41934 13.095 9.41934C13.0605 9.4184 13.0251 9.41561 12.9906 9.41095C12.9561 9.40629 12.9216 9.40069 12.8871 9.3923C12.8704 9.38858 12.8526 9.38392 12.8359 9.37926C12.8144 9.37273 12.793 9.36621 12.7725 9.35875C12.7436 9.3485 12.7156 9.33731 12.6867 9.32426C12.6541 9.30935 12.6224 9.29257 12.5907 9.27486C12.5749 9.26554 12.56 9.25622 12.5441 9.24597C12.4677 9.19656 12.3959 9.13598 12.3307 9.06607C12.1219 8.84237 12.0194 8.56088 12.0156 8.28032C12.0156 8.28032 12.0156 8.27938 12.0156 8.27845C12.0156 8.25981 12.0156 8.24117 12.0156 8.22253C12.0268 7.92239 12.1508 7.62785 12.3801 7.40787C12.4686 7.32305 12.5684 7.25688 12.6737 7.20747C12.7035 7.19349 12.7343 7.18138 12.766 7.17019C12.875 7.13197 12.9887 7.11147 13.1024 7.1096C13.1509 7.10867 13.2003 7.11054 13.2488 7.11613C13.2814 7.11986 13.3131 7.12545 13.3457 7.13197C13.521 7.16833 13.6887 7.24942 13.8304 7.37432C13.9246 7.45728 14.0001 7.54769 14.0606 7.64556C14.0793 7.67539 14.0961 7.70521 14.111 7.73597C14.1222 7.75834 14.1324 7.78164 14.1417 7.80402C14.1986 7.94103 14.2284 8.08924 14.2312 8.2449C14.2266 8.58697 14.1175 8.87126 13.8835 9.09869H13.8854Z"
                    fill="#1D5558" />
                  <path
                    d="M22.5 3.85938H28.7227C29.0051 3.85938 29.1458 4.00571 29.1458 4.29653V6.17283H28.4123L28.3135 4.63488H24.504V8.54315H28.5111V9.31958H24.504V13.3975H28.4402L28.553 11.9015H29.2866V13.7219C29.2866 14.0136 29.1402 14.159 28.8494 14.159H22.5V13.4255L23.3752 13.3267V4.70572L22.5 4.59293V3.85938Z"
                    fill="#1D5558" />
                  <path
                    d="M40.2111 14.159H38.6452C38.3535 14.159 38.2081 14.0136 38.2081 13.7219V9.44635H33.3546V13.7219C33.3546 14.0136 33.2083 14.159 32.9175 14.159H31.3516V13.4255L32.2268 13.3127V4.70572L31.3516 4.59293V3.85938H32.9175C33.2092 3.85938 33.3546 4.00571 33.3546 4.29653V8.57204H38.2081V4.29653C38.2081 4.00478 38.3535 3.85938 38.6452 3.85938H40.2111V4.59293L39.3359 4.67775V13.3127L40.2111 13.4255V14.159Z"
                    fill="#1D5558" />
                  <path
                    d="M50.6796 14.159H49.7484C49.5033 14.159 49.3299 14.0649 49.2265 13.8766L44.2882 5.65086V13.7219C44.2882 14.0136 44.1419 14.159 43.8511 14.159H42.2852V13.4255L43.1604 13.3267V4.70572L42.2852 4.59293V3.85938H44.0916C44.3171 3.85938 44.4914 3.95352 44.6135 4.1418L49.5518 12.3815V4.29653C49.5518 4.00478 49.6925 3.85938 49.9749 3.85938H51.5548V4.59293L50.6796 4.70572V14.159Z"
                    fill="#1D5558" />
                  <path
                    d="M53.1445 9.00368C53.1445 7.29142 53.509 5.97251 54.2379 5.046C54.9668 4.1195 55.9734 3.65625 57.2569 3.65625C58.5404 3.65625 59.5499 4.1195 60.2834 5.046C61.017 5.97251 61.3843 7.29142 61.3843 9.00368C61.3843 10.7159 61.017 12.0349 60.2834 12.9614C59.5499 13.8879 58.5414 14.3511 57.2569 14.3511C55.9725 14.3511 54.9668 13.8879 54.2379 12.9614C53.509 12.0349 53.1445 10.7159 53.1445 9.00368ZM60.2555 9.00368C60.2555 7.56452 59.9898 6.4572 59.4585 5.68076C58.9272 4.90433 58.1937 4.51657 57.2579 4.51657C56.322 4.51657 55.5885 4.90433 55.0572 5.68076C54.5259 6.4572 54.2603 7.56452 54.2603 9.00368C54.2603 10.4428 54.5259 11.5502 55.0572 12.3266C55.5885 13.103 56.322 13.4908 57.2579 13.4908C58.1937 13.4908 58.9272 13.103 59.4585 12.3266C59.9898 11.5502 60.2555 10.4428 60.2555 9.00368Z"
                    fill="#1D5558" />
                  <path
                    d="M63.1217 3.85249H69.5839C69.8756 3.85249 70.0211 3.99883 70.0211 4.28965V6.20883H69.2875L69.1747 4.62893H66.9172V13.3207L68.1867 13.4195V14.1531H64.518V13.4195L65.7875 13.3207V4.628H63.5299L63.4172 6.2079H62.6836V4.28872C62.6836 3.99697 62.829 3.85156 63.1207 3.85156L63.1217 3.85249Z"
                    fill="#1D5558" />
                  <path
                    d="M71.3203 3.85938H77.543C77.8254 3.85938 77.9662 4.00571 77.9662 4.29653V6.17283H77.2326L77.1338 4.63488H73.3243V8.54315H77.3314V9.31958H73.3243V13.3975H77.2606L77.3733 11.9015H78.1069V13.7219C78.1069 14.0136 77.9606 14.159 77.6697 14.159H71.3203V13.4255L72.1956 13.3267V4.70572L71.3203 4.59293V3.85938Z"
                    fill="#1D5558" />
                </svg>
              </p>
            </div>
          </div>
        </div>
        }

        <!-- Your details Section -->
        @if (activeTab === 2) {
          
        <div class="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-center p__35--px p-lg-5 position-relative">
          @if(isOtpLoading) {
            <div class="login__form--overlay">
              <div class="login__form--spinner"></div>
            </div>
          }
          <!-- SCREEN 1: Select Email or Mobile -->
          <form [formGroup]="verificationMethod" (ngSubmit)="nextTab('sendOtp')" class="w-100">
            <a id="pl__methodback" (click)="nextTab('backToLogin')"
              class="bg-light border rounded d-flex justify-content-center align-items-center mb-3"
              style="width:40px;height:40px;" >
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                <path d="M0 7.99548C0 8.15208 0.0282908 8.29663 0.0848723 8.42914C0.147741 8.56164
                                0.242043 8.68812 0.36778 8.80858L7.71395 15.6928C7.9277 15.8976 8.18546
                                16 8.48723 16C8.6947 16 8.88016 15.9518 9.04362 15.8554C9.21336 15.7651
                                9.34853 15.6386 9.44912 15.476C9.54971 15.3194 9.6 15.1447 9.6
                                14.952C9.6 14.6629 9.48369 14.4069 9.25108 14.1841L2.63104
                                7.99548L9.25108 1.80689C9.48369 1.58404 9.6 1.33107 9.6
                                1.048C9.6 0.849238 9.54971 0.67156 9.44912 0.514963C9.34853
                                0.358366 9.21336 0.234896 9.04362 0.144551C8.88016 0.0481837
                                8.6947 0 8.48723 0C8.18546 0 7.9277 0.0993789 7.71395
                                0.298137L0.36778 7.18238C0.242043 7.30284 0.147741
                                7.42932 0.0848723 7.56183C0.0282908 7.69433 0
                                7.83889 0 7.99548Z" fill="#1D1D1D" />
              </svg>
            </a>

            <h1 class="fw__6-- fs__30-- tc__101828-- lh__38--px mt-2 mb-3 pl__10--px p-0">
              {{ 'Choose a way to confirm its you' | translate }}
            </h1>
            <h3 class="fw__5-- fs__18-- tc__475467-- mb-3 pl__10--px p-0">
              {{ 'These are your available confirmation methods.' | translate }}
            </h3>
            <!-- Email Radio -->
            <div class="radio__style--1 border-0 d-flex justify-content-between align-items-center"
              [class.opacity-50]="!hasEmail">
              <div class="d-flex flex-column cursor-pointer">
                <label for="pl__email" class="fw__6-- fs__16-- tc__344054-- lh__20--px mb-1">{{ 'Email' | translate }}</label>
                <label for="pl__email" class="fw__5-- fs__16-- tc__344054-- lh__20--px mb-1">
                  {{ 'We\'ll send a code to your email' | translate }}
                </label>
              </div>
              <input type="radio" formControlName="validateOption" value="email" id="pl__email" [disabled]="!hasEmail"
                >
            </div>

            <hr class="my-3 tc__1D1D1D--">

            <!-- Mobile Radio -->
            <div class="radio__style--1 border-0 d-flex justify-content-between align-items-center"
              [class.opacity-50]="!hasMobile">
              <div class="d-flex flex-column cursor-pointer">
                <label for="pl__mobile" class="fw__6-- fs__16-- tc__344054-- lh__20--px mb-1">{{ 'Mobile' | translate }}</label>
                <label for="pl__mobile" class="fw__5-- fs__16-- tc__344054-- lh__20--px mb-1">
                  {{ 'We\'ll send a code to your mobile' | translate }}
                </label>
              </div>
              <input type="radio" formControlName="validateOption" value="number" id="pl__mobile"
                [disabled]="!hasMobile" >
            </div>

            <div class="mt-4">
              <button type="submit" [disabled]="isOtpLoading" class="btn__l-- btn__006080--f mb-3" id="pl__requestotp">
                {{ 'Request OTP' | translate }}
                <!-- <ng-container *ngIf="!isOtpLoading; else loading">{{ 'Request OTP' | translate }}</ng-container>
                <ng-template #loading>
                  <div class="spinner"></div>
                </ng-template> -->
              </button>
            </div>
          </form>
        </div>
        }


        <!-- OTP Screen -->
        @if(activeTab === 3) {
        <div class="col-12 col-lg-6 position-relative">
          @if(isSubmitOtpLoading) {
            <div class="login__form--overlay">
              <div class="login__form--spinner"></div>
            </div>
          }
          <div class="d-flex justify-content-center flex-column align-items-center p-4 p-md-5 h-100">
            <div class="w-100">
              <a (click)="nextTab('back')" id="pl__mobileforotp"
                class="bg-light rounded border d-flex align-items-center justify-content-center mb-3"
                style="width:40px;height:40px;" >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                  <path
                    d="M0 7.99548C0 8.15208 0.0282908 8.29663 0.0848723 8.42914C0.147741 8.56164 0.242043 8.68812 0.36778 8.80858L7.71395 15.6928C7.9277 15.8976 8.18546 16 8.48723 16C8.6947 16 8.88016 15.9518 9.04362 15.8554C9.21336 15.7651 9.34853 15.6386 9.44912 15.476C9.54971 15.3194 9.6 15.1447 9.6 14.952C9.6 14.6629 9.48369 14.4069 9.25108 14.1841L2.63104 7.99548L9.25108 1.80689C9.48369 1.58404 9.6 1.33107 9.6 1.048C9.6 0.849238 9.54971 0.67156 9.44912 0.514963C9.34853 0.358366 9.21336 0.234896 9.04362 0.144551C8.88016 0.0481837 8.6947 0 8.48723 0C8.18546 0 7.9277 0.0993789 7.71395 0.298137L0.36778 7.18238C0.242043 7.30284 0.147741 7.42932 0.0848723 7.56183C0.0282908 7.69433 0 7.83889 0 7.99548Z"
                    fill="#1D1D1D" />
                </svg>
              </a>

              <h4 class="fs__30-- fw__6-- tc__101828--">{{ 'Please Enter OTP' | translate }}</h4>

              <p class="fs__18-- fw__5-- tc__475467--">
                {{ 'Enter the code we sent to your mobile/email' | translate }}
              </p>

              <form name="otpForm" autocomplete="off" [formGroup]="otpForm" (ngSubmit)="nextTab('verifyOTP')"
                novalidate>
                <!-- OTP INPUTS -->
                <div class="row my-5 text-center">
                  @for (part of ['one','two','three','four']; track part; let i = $index) {
                  <div class="col-3 input__style--1">
                    <input [id]="'pl__otp' + i" type="text" maxlength="1" inputmode="numeric" (focus)="selectInput($event)"
    (click)="selectInput($event)" pattern="[0-9]*" class="text-center"
                      placeholder="-" [formControlName]="part" #otpInput (input)="moveNext($event, i)"
                      (keydown)="movePrev($event, i)"  (keypress)="allowOnlyNumbers($event)"/>
                  </div>
                  }
                </div>

                <!-- ERROR / TIMER / RESEND SECTION -->
                <div class="d-flex justify-content-between mb-3 align-items-center">

                  <!-- OTP EXPIRED -->
                  @if (ResendOtpButton) {
                  <small class="fs__18-- fw__5-- tc__C71D27--">
                    {{ 'OTP Expired' | translate }}
                  </small>
                  }

                  <!-- OTP TIMER -->
                  @if (showTimer) {
                  <small class="fs__18-- fw__5-- tc__475467--" >
                    {{ 'OTP Expires in' | translate }}
                    <span class="fs__18-- fw__5-- tc__006080--">
                      {{ otpTimerSeconds | countDown }}
                    </span>
                  </small>
                  }

                  <!-- RESEND OTP -->
                  @if (ResendOtpButton) {
                  <a id="pl__resendotp" class="c__p-- fs__16-- fw__5-- tc__475467-- text-decoration-none d-flex align-items-center gap-2"
                    (click)="resendOtp()">

                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path d="M3.80687 11.1728C3.61187 10.5203 3.48438 9.80031 3.48438 9.00531
                        C3.48438 5.41281 6.39438 2.50281 9.98688 2.50281
                        C13.5794 2.50281 16.4894 5.41281 16.4894 9.00531
                        C16.4894 12.5978 13.5794 15.5078 9.98688 15.5078
                        C8.65188 15.5078 7.40687 15.1028 6.37187 14.4128" stroke="#B8B8B8" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3.99 12.1016L1.5 9.93406" stroke="#B8B8B8" stroke-width="1.3" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M3.99219 12.1016L5.83719 9.57406" stroke="#B8B8B8" stroke-width="1.3"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    {{ 'Resend OTP' | translate }}
                  </a>
                  }
                </div>

                <!-- OTP VALIDATION ERRORS -->
                @if (otpInvalid && !ResendOtpButton && otpForm.invalid) {
                <small class="fs__18-- fw__5-- tc__C71D27-- d-block mb-2 text-center">
                  {{ 'The OTP you entered is incorrect. Please check the code and try again.' | translate }}
                </small>
                }

                @if (otpValidationFailed && !ResendOtpButton) {
                <small class="fs__18-- fw__5-- tc__C71D27-- d-block mb-2 text-center">
                  {{ 'OTP verification failed. Please try again.' | translate }}
                </small>
                }

                <!-- VERIFY BUTTON -->
                <button type="submit" class="btn__l-- btn__006080--f" id="pl__validateotp"
                  [disabled]="isSubmitOtpLoading || otpForm.invalid || ResendOtpButton" >
                    {{ 'Verify' | translate }}
                  <!-- <ng-container *ngIf="!isSubmitOtpLoading; else loading">
                    {{ 'Verify' | translate }}
                  </ng-container>

                  <ng-template #loading>
                    <div class="spinner"></div>
                  </ng-template> -->
                </button>

              </form>

            </div>
          </div>
        </div>
        }

        <!-- Register With Mobile number -->
        @if ((authFlowState.isSignup && (activeTab === 4 || activeTab === 5 || activeTab === 6 || activeTab === 7)) ||
        (authFlowState.isForgotPassword && (activeTab === 4 || activeTab === 5 || activeTab === 7))) {
        <div class="col-12 col-lg-6 position-relative" [class.h-100]="activeTab === 5">
          @if(isOtpLoading || chooseAndConfirmLoad) {
            <div class="login__form--overlay">
              <div class="login__form--spinner"></div>
            </div>
          }
          <div class="d-flex justify-content-center flex-column align-items-center px-4 px-lg-5 pt-4 pb-4 h-100">

            <!-- SCREEN 1: ENTER MOBILE NUMBER -->
            @if (activeTab === 4) {
            <div class="w-100 h-100 d-flex flex-column justify-content-center">
              <div>
                <div class="text-center">
                  <div class="bg-white border p-3 rounded d-inline-block" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <path
                        d="M24 25.1441H22.9867C21.92 25.1441 20.9067 25.5574 20.16 26.3041L17.88 28.5574C16.84 29.5841 15.1467 29.5841 14.1067 28.5574L11.8267 26.3041C11.08 25.5574 10.0533 25.1441 9 25.1441H8C5.78667 25.1441 4 23.3707 4 21.1841V6.62406C4 4.4374 5.78667 2.66406 8 2.66406H24C26.2133 2.66406 28 4.4374 28 6.62406V21.1707C28 23.3574 26.2133 25.1441 24 25.1441Z"
                        stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M16.0993 11.9266C16.046 11.9266 15.9659 11.9266 15.8993 11.9266C14.4993 11.8732 13.3926 10.7399 13.3926 9.32656C13.3926 7.88656 14.5526 6.72656 15.9926 6.72656C17.4326 6.72656 18.5926 7.8999 18.5926 9.32656C18.6059 10.7399 17.4993 11.8866 16.0993 11.9266Z"
                        stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M12.3378 15.9375C10.5645 17.1242 10.5645 19.0575 12.3378 20.2442C14.3511 21.5908 17.6578 21.5908 19.6711 20.2442C21.4445 19.0575 21.4445 17.1242 19.6711 15.9375C17.6578 14.6042 14.3645 14.6042 12.3378 15.9375Z"
                        stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>

                <h4 class="mt-3 mb-2 text-center fs__24-- fw__6-- tc__101828--">
                  {{ 'Enter the mobile number you’ve registered with us' | translate }}
                </h4>

                <p class="mb-2 text-center fs__14-- fw__5-- tc__475467--">
                  {{ 'We’ll send a code to the provided registered number' | translate }}
                </p>

                <form class="row" [formGroup]="verificationForm" (ngSubmit)="nextTab('sendOtp')" novalidate
                  autocomplete="off">
                  <div class="col-xl-12 col-sm-12 mb-3">
                    <label class="fw__5-- fs__14-- tc__344054-- mb-2">{{ 'Mobile Number' | translate }} <span class="text-danger">*</span></label>
                    <div class="d-flex  flex-row gap-1">
                      <div class="input__style--1">
                        <select class="rounded-0 rounded-start custom__arrow--" formControlName="CountryCodeforMobile"
                          id="pl__countrycodemob" style="width:100px;" >
                          @for(country of allCountryCodeList; track country.Id){
                          <option [value]="country.Id">{{ country.InternationalDialing }}</option>
                          }
                        </select>
                      </div>
                      <div class="input__style--1 w-100"
                        [class.has-error]="(hasMobileNumber && verificationForm.controls.Mobileno.value.length !== 14) || (noPatientFound && verificationForm.controls.Mobileno.value.length === 14)">
                        <input type="text" maxlength="14" formControlName="Mobileno" class="rounded-0 rounded-end"
                          placeholder="(000) 000-0000" id="pl__mobnumber" UsMobileFormater required >
                        @if (hasMobileNumber && verificationForm.controls.Mobileno.value.length !== 14) {
                        <small class="text-danger">{{ 'Please enter valid mobile number' | translate }}</small>
                        }
                        @if (noPatientFound && verificationForm.controls.Mobileno.value.length === 14) {
                        <small class="text-danger">{{ 'No patient is registered under this mobile number.' | translate }}</small>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-4">
                    <button type="submit" [disabled]="isOtpLoading" class="btn__l-- btn__006080--f mb-3"
                      id="pl__requestotp" >{{ 'Request OTP' | translate }}
                      <!-- <ng-container *ngIf="!isOtpLoading; else loading">{{ 'Request OTP' | translate }}</ng-container>
                      <ng-template #loading>
                        <div class="spinner"></div>
                      </ng-template> -->
                    </button>

                    <div class="text-center">
                      <span class="tc__475467-- fw__4-- fs__14-- lh__19--px">
                        {{ 'Already have an account?' | translate }} <a (click)="nextTab('backToLogin')"
                          class="text-decoration-none tc__006080-- fw__6-- fs__14-- lh__19--px c__p--" id="pl__login"
                          >{{ 'Login here' | translate }}</a>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <!-- FOOTER -->
            <div class="row mt-4">
              <div class="col-lg-12">
                <div class="row justify-content-center align-items-center text-center text-md-start flex-md-row mt-3">

                  <div class="col-auto mb-2 mb-md-0" >
                    <p class="m-0 fs__13-- tc__1D1D1D-- fw__5-- fs__normal--">© 2025 EHNOTE Care</p>
                  </div>

                  <div class="col-auto">
                    <ul class="list-inline mb-0 lh__15--px" >
                      <li class="list-inline-item">
                        <a id="pl__signupprivacy" class="text-decoration-none fs__13-- fw__5-- fs__normal-- tc__006080--"
                          href="https://www.ehnote.com/ehr/Privacy-Policy.html" target="_blank">
                          {{ 'Privacy Policy' | translate }}
                        </a>
                      </li>
                      <li class="list-inline-item">
                        <p class=" fs__13-- tc__1D1D1D-- fw__5-- fs__normal-- m-0">{{ 'and' | translate }}</p>
                      </li>
                      <li class="list-inline-item">
                        <a id="pl__signupterms" class="text-decoration-none  fs__13-- fw__5-- fs__normal-- tc__006080--"
                          href="https://www.ehnote.com/ehr/TermsOfService.html" target="_blank">
                          {{ 'Terms of Services' | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            }

            <!-- SCREEN 5: MULTIPLE USERS LIST -->
            @if(activeTab === 5){
            <div class="w-100 h-100 d-flex flex-column align-items-md-center">

              <!-- Heading -->
              <h4 class="fs__26-- fw__5-- tc__101828-- fs__normal-- mb-4">{{ 'Looks like this contact is shared by multiple patients.' | translate }}</h4>
              <div class="col-xl-9 col-md-12 h-100">

                <div class="d-flex flex-column h-100">

                  <!-- Scrollable User List Container -->
                  <div class="bg__F6F6F6-- p-3 w-100 h-100 rounded-3">

                    <!-- Scrollable list -->
                    <div class="position-relative h-100">
                      <div class="adjustable__position-- slim__scroll--">

                        <form name="usersList" autocomplete="off" [formGroup]="patientSelectForm">
                          <ul class="list-unstyled m-0 p-0" >

                            @for (patient of NewSignUpPatientList; track patient) {
                            <li [id]="'pl__patientcard' + $index" class="d-flex align-items-center p-3 mb-2 border rounded bg__FFFFFF--"
                              style="cursor:pointer;" (click)="onSelectPatient(patient)">

                              <!-- Avatar -->
                              <div class="me-3">
                                @if(patient.ImageUrl){
                                <img [src]="patient.ImageUrl" width="50" height="50" class="rounded-circle" />
                                }@else {
                                <img src="Images/no-profile.png" width="50" height="50" class="rounded-circle" />
                                }
                              </div>

                              <!-- Text -->
                              <div class="flex-grow-1">
                                <div class="fw__5-- fs__18-- tc__1D1D1D-- fs__normal--">
                                  {{ patient.FirstName }} {{ patient.LastName }}
                                </div>
                                <small class="fw__4-- fs__14-- tc__656565-- fs__normal--">
                                  {{ patient.EmailId | maskedtext}}
                                </small>
                              </div>
                              <div class="radio__style--1 border-0">
                                <input type="radio" id="patient-{{patient.PatientId}}" name="selectedPatientId"
                                  formControlName="selectedPatientId" [value]="patient.PatientId" />
                              </div>
                            </li>
                            }
                          </ul>
                        </form>
                      </div>
                    </div>
                  </div>

                  <!-- Buttons -->
                  <div class="d-flex flex-column gap-2 mb-3 mt-4">

                    <!-- Continue -->
                    <button (click)="nextTab('PatentSelection')" class="btn__m-- btn__006080--f w-100" id="pl__continue"
                      >
                      {{ 'Continue' | translate }}
                    </button>

                    <!-- Back to Login -->
                    <button type="button" class="btn__m-- btn__006080--o w-100" (click)="nextTab('backToLogin')"
                      id="pl__backlogin" >
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none"
                        class="me-2">
                        <path d="M11 5H1M1 5L5 9M1 5L5 1" stroke="#006080" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"></path>
                      </svg>
                      {{ 'Back to Login' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            }


            <!-- SCREEN 4: USER DETAILS FORM -->
            @if (activeTab === 6) {
            <div class="w-100">
              <div class="bg-white border rounded p-3 mx-auto text-center" style="width: 80px;" >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M24 25.1441H22.9867C21.92 25.1441 20.9067 25.5574 20.16 26.3041L17.88 28.5574C16.84
                    29.5841 15.1467 29.5841 14.1067 28.5574L11.8267 26.3041C11.08 25.5574 10.0533
                    25.1441 9 25.1441H8C5.78667 25.1441 4 23.3707 4 21.1841V6.62406C4 4.4374
                    5.78667 2.66406 8 2.66406H24C26.2133 2.66406 28 4.4374 28 6.62406V21.1707C28
                    23.3574 26.2133 25.1441 24 25.1441Z" stroke="#1D1D1D" stroke-width="2" />
                  <path d="M16.0993 11.9266C14.4993 11.8732 13.3926 10.7399 13.3926 9.32656C13.3926 7.88656
                    14.5526 6.72656 15.9926 6.72656C17.4326 6.72656 18.5926 7.8999 18.5926
                    9.32656C18.6059 10.7399 17.4993 11.8866 16.0993 11.9266Z" stroke="#1D1D1D" stroke-width="2" />
                  <path d="M12.3378 15.9375C10.5645 17.1242 10.5645 19.0575 12.3378 20.2442C14.3511 21.5908
                    17.6578 21.5908 19.6711 20.2442C21.4445 19.0575 21.4445 17.1242 19.6711
                    15.9375C17.6578 14.6042 14.3645 14.6042 12.3378 15.9375Z" stroke="#1D1D1D" stroke-width="2" />
                </svg>
              </div>

              <h4 class="fw__6-- mt-3 mb-2 tc__101828-- fs__20-- text-center">{{ 'Your details' | translate }}</h4>

              <p class="fs__14-- fw__5-- tc__475467-- text-center mb-3">
                {{ 'Please provide necessary details and continue to create account' | translate }}
              </p>

              <form class="row gy-3" autocomplete="off" (ngSubmit)="nextTab('isValidPatientOrNot')"
                [formGroup]="personalDetailsForm">

                <div class="col-xl-6 col-sm-12">
                  <div class="input__style--1"
                    [class.has-error]="personalDetailsForm.controls.firstName.invalid && personalDetailsSubmitted">
                    <label for="ba__firstname">{{ 'First Name' | translate }} <span class="text-danger">*</span></label>
                    <input type="text" [placeholder]="'First Name' | translate" formControlName="firstName" id="ba__firstname"
                       />
                    @if (personalDetailsForm.controls.firstName.invalid && personalDetailsSubmitted) {
                    <small class="text-danger">{{ 'First name is required.' | translate }}</small>
                    }
                    @if (isFirstNameMismatch) {
                    <small class="text-danger">{{ 'First name does not match selected patient.' | translate }}</small>
                    }
                  </div>
                </div>

                <div class="col-xl-6 col-sm-12">
                  <div class="input__style--1"
                    [class.has-error]="personalDetailsForm.controls.lastName.invalid && personalDetailsSubmitted">
                    <label for="ba__lastname">{{ 'Last Name' | translate }} <span class="text-danger">*</span></label>
                    <input type="text" [placeholder]="'Last Name' | translate" formControlName="lastName" id="ba__lastname"  />
                    @if (personalDetailsForm.controls.lastName.invalid && personalDetailsSubmitted) {
                    <small class="text-danger">{{ 'Last name is required.' | translate }}</small>
                    }
                    @if (isLastNameMismatch) {
                    <small class="text-danger">{{ 'Last name does not match selected patient.' | translate }}</small>
                    }
                  </div>
                </div>

                <div class="col-xl-6 col-sm-12">
                  <div class="input__style--1">
                    <label>{{ 'Gender' | translate }} <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="gender" id="pl__gender" >
                      <option value="" disabled>{{ 'Select' | translate }}</option>
                      <option value="Male">{{ 'Male' | translate }}</option>
                      <option value="Female">{{ 'Female' | translate }}</option>
                      <option value="Prefer not to tell">{{ 'Prefer not to tell' | translate }}</option>
                      <option value="Unknown">{{ 'Unknown' | translate }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-xl-6 col-sm-12">
                  <div class="input__style--1 position-relative"
                       [class.has-error]="(personalDetailsForm.controls.dob.invalid && personalDetailsSubmitted) || personalDetailsForm.get('dob')?.hasError('directiveError') || isDobMismatch">

                    <label>{{ 'Date of Birth' | translate }} <span class="text-danger">*</span></label>

                    <input id="pl__detailsdob" placeholder="mm-dd-yyyy" formControlName="dob" datepickerManualAndCalSelection
                           [isDob]="true" />

                    <a class="position-absolute tu__40--px ru__20--px">
                      <svg class="icon__20-- tc__656565--">
                        <use href="../Images/icons__sprite.svg#icon__calendar--o"></use>
                      </svg>
                    </a>
                    @if (personalDetailsForm.controls.dob.invalid && personalDetailsSubmitted &&
                    personalDetailsForm.get('dob')?.hasError('required')) {
                    <small class="text-danger">{{ 'Please Enter Date Of Birth' | translate }}</small>
                    }

                    @if (personalDetailsForm.get('dob')?.hasError('directiveError')) {
                    <small class="text-danger">
                      {{ personalDetailsForm.get('dob')?.getError('directiveError') | translate }}
                    </small>
                    }

                    @if (!personalDetailsForm.controls.dob.invalid && isDobMismatch) {
                    <small class="text-danger">{{ 'Date of birth does not match.' | translate }}</small>
                    }
                  </div>
                </div>
                <div class="col-xl-6 col-sm-12">
                  <div class="input__style--1"
                    [class.has-error]="personalDetailsForm.controls.phone.invalid && personalDetailsSubmitted">
                    <label for="ba__phone">{{ 'Phone Number' | translate }} <span class="text-danger">*</span></label>
                    <input type="text" [placeholder]="'Number' | translate" formControlName="phone" id="ba__phone" UsMobileFormater
                       />
                    @if (personalDetailsForm.controls.phone.invalid && personalDetailsSubmitted) {
                    <small class="text-danger">{{ 'Phone number is required.' | translate }}</small>
                    }
                    @if (isMobileMismatch) {
                    <small class="text-danger">{{ 'Mobile number does not match selected patient.' | translate }}</small>
                    }
                  </div>
                </div>

                <div class="col-xl-6 col-sm-12">
                  <div class="input__style--1">
                    <label for="ba__zip">{{ 'Zip Code' | translate }}</label>
                    <input type="number" maxlength="6" placeholder="123456" id="ba__zip" formControlName="zip"
                       />
                  </div>
                </div>

                <div class="col-12 mt-4">
                  <button type="submit" class="btn__006080--f btn__l-- mb-3" id="pl__verify">
                    {{ 'Verify & Continue' | translate }}
                  </button>

                  <p class="text-center tc__475467-- fw__4-- fs__14-- lh__19--px">
                    {{ 'Already have an account?' | translate }}
                    <a (click)="nextTab('backToLogin')"
                      class="text-decoration-none tc__006080-- fw__6-- fs__14-- lh__19--px c__p--" id="pl__login"
                      >{{ 'Login here' | translate }}</a>
                  </p>
                </div>

              </form>
            </div>
            }

            <!-- SCREEN 6: CREATE ACCOUNT – CREDENTIALS -->
            @if(activeTab === 7){
            <div class="w-100">
              <div class="bg-white border rounded p-3 d-block mx-auto text-center" style="width: 80px;" >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M8 13.3307V10.6641C8 6.25073 9.33333 2.66406 16 2.66406C22.6667 2.66406
                                        24 6.25073 24 10.6641V13.3307" stroke="#1D1D1D" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M22.666 29.3359H9.33268C3.99935 29.3359 2.66602 28.0026 2.66602 22.6693V20.0026C2.66602
                                        14.6693 3.99935 13.3359 9.33268 13.3359H22.666C27.9993 13.3359 29.3327 14.6693
                                        29.3327 20.0026V22.6693C29.3327 28.0026 27.9993 29.3359 22.666 29.3359Z"
                    stroke="#1D1D1D" stroke-width="2" />
                  <path d="M21.3254 21.3307H21.3373" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M15.9933 21.3307H16.0053" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M10.6593 21.3307H10.6713" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>

              <h4 class="fw__6-- fs__24-- tc__101828-- text-center mt-3 mb-2">{{ 'Choose your credentials' | translate }}</h4>

              <form class="row gy-3 mt-3" [formGroup]="chooseAndConfirmPassword"
                (ngSubmit)="nextTab('AddUpdatePatientSignUp')" autocomplete="off">

                <!-- EMAIL — hide if not signup and no email value -->
                @if (isSignupFlow || chooseAndConfirmPassword.controls.email.value) {
                <div class="col-12">
                  <div class="input__style--1"
                    [class.has-error]="chooseAndConfirmPassword.controls.email.invalid && (hasValuesInInputs || chooseAndConfirmPassword.controls.email.touched)">
                    <label>{{ 'Email' | translate }}</label>
                    <input type="email" [placeholder]="'Enter your email address' | translate" formControlName="email" id="pl__email"
                       [readonly]="!isSignupFlow">

                    @if (isSignupFlow && (hasValuesInInputs || chooseAndConfirmPassword.controls.email.touched) &&
                    chooseAndConfirmPassword.controls.email.invalid) {
                    <small class="text-danger">
                      @if (chooseAndConfirmPassword.controls.email.errors?.['email']) {
                      {{ 'Please enter a valid email address.' | translate }}
                      }
                    </small>
                    }
                  </div>
                </div>
                }

                <!-- USERNAME — hide if not signup and no username value -->
                @if (isSignupFlow || chooseAndConfirmPassword.controls.userName.value) {
                <div class="col-12">
                  <div class="input__style--1"
                    [class.has-error]="chooseAndConfirmPassword.controls.userName.invalid && (hasValuesInInputs || chooseAndConfirmPassword.controls.userName.touched)">
                    <label>{{ 'Username' | translate }} <span class="text-danger" *ngIf="isSignupFlow">*</span></label>
                    <input type="text" [placeholder]="'Choose any username' | translate" formControlName="userName" id="pl__username"
                       [readonly]="!isSignupFlow">

                    @if (isSignupFlow) {
                    @if ((hasValuesInInputs || chooseAndConfirmPassword.controls.userName.touched) &&
                    chooseAndConfirmPassword.controls.userName.errors?.['required']) {
                    <small class="text-danger">{{ 'Username is required.' | translate }}</small>
                    }
                    @else if (chooseAndConfirmPassword.controls.userName.errors?.['alreadyExists']) {
                    <small class="text-danger">{{ 'Username already exists.' | translate }}</small>
                    }
                    @else if (chooseAndConfirmPassword.controls.userName.errors?.['serverError']) {
                    <small class="text-danger">{{ 'Something went wrong. Please try again.' | translate }}</small>
                    }
                    }
                  </div>
                </div>
                }

                <!-- USE EMAIL AS USERNAME — only show in signup flow -->
                @if (isSignupFlow) {
                <div class="col-12">
                  <div class="checkbox__style--1">
                    <input type="checkbox" id="pl__useEmailUsername"
                      [disabled]="!chooseAndConfirmPassword.controls.email.value || chooseAndConfirmPassword.controls.email.invalid"
                      [checked]="!!chooseAndConfirmPassword.controls.email.value && chooseAndConfirmPassword.controls.userName.value === chooseAndConfirmPassword.controls.email.value"
                      (change)="chooseAndConfirmPassword.controls.userName.setValue( $event.target.checked ? chooseAndConfirmPassword.controls.email.value : '' )">
                    <label for="pl__useEmailUsername">
                      {{ 'Use my email address as my username' | translate }}
                    </label>
                  </div>
                </div>
                }

                <!-- PASSWORD HEADING -->
                <div class="col-12">
                  <h5 class="fs__17-- fw__6-- tc__344054-- mb-1 mt-3">
                    {{ 'Create a strong password' | translate }}
                  </h5>
                </div>

                <!-- PASSWORD -->
                <div class="col-xl-6 col-sm-12 m-0">
                  <div class="input__style--1 position-relative"
                    [class.has-error]="chooseAndConfirmPassword.controls.password.invalid && (hasValuesInInputs || chooseAndConfirmPassword.controls.password.touched)">
                    <label>{{ 'Password' | translate }} <span class="text-danger">*</span></label>
                    <input [type]="showPassword ? 'text' : 'password'" [placeholder]="'Choose a password' | translate"
                      formControlName="password" id="pl__password" >

                    @if ((hasValuesInInputs || chooseAndConfirmPassword.controls.password.touched) &&
                    chooseAndConfirmPassword.controls.password.invalid) {
                    <small class="text-danger">
                      @if (chooseAndConfirmPassword.controls.password.errors?.['required']) {
                      {{ 'Password is required.' | translate }}
                      }
                      @if (chooseAndConfirmPassword.controls.password.errors?.['minlength']) {
                      {{ 'Password must be at least 8 characters.' | translate }}
                      }
                    </small>
                    }
                    <div class="position-absolute c__p-- tu__40--px ru__24--px">
                      @if(!showPassword){
                      <svg id="pl__newpasswordshow" class="icon__16--" (click)="togglePassword()">
                        <use href="../Images/icons__sprite.svg#icon__passwordshow"></use>
                      </svg>
                      }
                      @if (showPassword) {
                      <svg id="pl__newpasswordhide" class="icon__16--" (click)="togglePassword()">
                        <use href="../Images/icons__sprite.svg#icon__passwordhide"></use>
                      </svg>
                      }
                    </div>
                  </div>
                </div>

                <!-- CONFIRM PASSWORD -->
                <div class="col-xl-6 col-sm-12 m-0">
                  <div class="input__style--1 position-relative"
                    [class.has-error]="(chooseAndConfirmPassword.controls.confirmPassword.invalid && (hasValuesInInputs || chooseAndConfirmPassword.controls.confirmPassword.touched)) || (chooseAndConfirmPassword.controls.confirmPassword.valid && passwordMismatch)">
                    <label>{{ 'Confirm Password' | translate }} <span class="text-danger">*</span></label>
                    <input [type]="confirmPassword ? 'text' : 'password'" [placeholder]="'Confirm your password' | translate"
                      formControlName="confirmPassword" id="pl__confpassword" >

                    @if ((hasValuesInInputs || chooseAndConfirmPassword.controls.confirmPassword.touched) &&
                    chooseAndConfirmPassword.controls.confirmPassword.invalid && !passwordMismatch) {
                    <small class="text-danger">{{ 'Confirm password is required.' | translate }}</small>
                    }
                    @if (passwordMismatch) {
                    <small class="text-danger">{{ 'Password and Confirm Password do not match.' | translate }}</small>
                    }
                    <div class="position-absolute c__p-- tu__40--px ru__24--px">
                      @if(!confirmPassword){
                      <svg id="pl__confpasswordshow" class="icon__16--" (click)="toggleCPassword()">
                        <use href="../Images/icons__sprite.svg#icon__passwordshow"></use>
                      </svg>
                      }
                      @if (confirmPassword) {
                      <svg id="pl__confpasswordhide" class="icon__16--" (click)="toggleCPassword()">
                        <use href="../Images/icons__sprite.svg#icon__passwordhide"></use>
                      </svg>
                      }
                    </div>
                  </div>
                </div>

                <!-- SUBMIT -->
                <div class="col-12 mt-4">
                  <button type="submit" [disabled]="chooseAndConfirmLoad" class="btn__l-- btn__006080--f mb-4" 
                    id="pl__createaccount">{{ (isSignupFlow ? 'Create my account' : 'Update Password') | translate }}
                    <!-- <ng-container *ngIf="!chooseAndConfirmLoad; else loading">
                      {{ (isSignupFlow ? 'Create my account' : 'Update Password') | translate }}
                    </ng-container>
                    <ng-template #loading>
                      <div class="spinner"></div>
                    </ng-template> -->
                  </button>

                  <p class="text-center tc__475467-- fw__4-- fs__14-- lh__19--px m-0">
                    {{ 'Already have an account?' | translate }}
                    <a (click)="nextTab('backToLogin')"
                      class="text-decoration-none tc__006080-- fw__6-- fs__xl-- lh__19--px c__p--" id="pl__login"
                      >
                      {{ 'Login here' | translate }}
                    </a>
                  </p>
                </div>

              </form>


            </div>
            }

            <!-- FOOTER -->
            @if (false) {
            <div class="row w-100 mt-4">
              <div class="col-lg-12">
                <div class="row justify-content-center align-items-center text-center text-md-start flex-md-row">
                  <div class="col-auto mb-2 mb-md-0">
                    <p class="mb-0 fw-semibold text-dark">
                      © <span id="year_footer"></span> {{ 'EHNOTE Care' | translate }}
                    </p>
                  </div>

                  <div class="col-auto">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item" >
                        <a id="pl__oldprivacy" href="https://www.ehnote.com/ehr/Privacy-Policy.html" target="_blank">
                          {{ 'Privacy Policy' | translate }}
                        </a>
                      </li>
                      <li class="list-inline-item">
                        <span class="fw-bold">{{ 'and' | translate }}</span>
                      </li>
                      <li class="list-inline-item">
                        <a id="pl__oldterms" href="https://www.ehnote.com/ehr/TermsOfService.html" target="_blank">
                          {{ 'Terms of Services' | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mobile small powered-by row (visible on small screens) -->
            <div class="w-100 d-block d-lg-none mt-3 text-center">
              <p class="mb-0 d-flex justify-content-center align-items-center gap-2" >
                <span class="text-primary fw-semibold">{{ 'POWERED BY' | translate }}</span>
                <span class="fw-bold">
                  <img src="Content/img/ehnote-dark-logo.svg" alt="EHNOTE" style="height:24px;">
                </span>
              </p>
            </div>
            }
          </div>
        </div>
        }

        <!--Forgot password-->
        @if (authFlowState.isForgotPassword && (activeTab === 8 || activeTab === 9)) {
        <div class="col-12 col-lg-6 d-flex justify-content-center flex-column align-items-center p-5 position-relative">
          @if(isItsYouLoading) {
          <div class="login__form--overlay">
            <div class="login__form--spinner"></div>
          </div>
          }
          @if (activeTab === 8) {
          <div class="row justify-content-center align-items-center h-100">
            <div class="col-xl-10 col-lg-5 col-md-8 col-sm-12">
              <div class="w-100 h-100">
                <div class="bg-white border p-3 rounded text-center mx-auto" style="width: 80px;" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path
                      d="M8 13.3307V10.6641C8 6.25073 9.33333 2.66406 16 2.66406C22.6667 2.66406 24 6.25073 24 10.6641V13.3307"
                      stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M22.668 29.3359H9.33464C4.0013 29.3359 2.66797 28.0026 2.66797 22.6693V20.0026C2.66797 14.6693 4.0013 13.3359 9.33464 13.3359H22.668C28.0013 13.3359 29.3346 14.6693 29.3346 20.0026V22.6693C29.3346 28.0026 28.0013 29.3359 22.668 29.3359Z"
                      stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21.3273 21.3307H21.3393" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M15.9914 21.3307H16.0034" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M10.6593 21.3307H10.6713" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>

                <h4 class="fw__6-- fs__24-- tc__101828--  text-center mt-3 mb-4">{{ 'Confirm it\'s you' | translate }}</h4>
                <p class="fw__6-- fs__16-- tc__344054-- lh__20--px text-center mb-3">
                  {{ 'Enter your username and date of birth to confirm it\'s your account.' | translate }}
                </p>

                <form class="row gy-3" [formGroup]="confirmItsYou" (ngSubmit)="nextTab('confirmItsYou')"
                  autocomplete="off" novalidate>

                  <div class="col-12">
                    <div class="input__style--1 mb-3"
                      [class.has-error]="(hasUserNameAndDob && confirmItsYou.controls.userName.invalid) || (userNameNotExist && confirmItsYou.controls.userName.valid)">
                      <label for="pl__username" class="mb-1">{{ 'Username' | translate }} <span class="text-danger">*</span></label>
                      <input type="text" id="pl__username" formControlName="userName"
                        [placeholder]="'Enter Username' | translate" >
                      @if(hasUserNameAndDob && confirmItsYou.controls.userName.invalid && !userNameNotExist){
                      <small class="text-danger">{{ 'Username is required' | translate }}</small>
                      }
                      @if(userNameNotExist && confirmItsYou.controls.userName.valid){
                      <small class="text-danger">{{ 'No record found for the entered username.' | translate }}</small>
                      }
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="input__style--1 position-relative"
                      [class.has-error]="(hasUserNameAndDob && confirmItsYou.controls.dob.invalid) || isItsNotYou">
                      <label for="pl__dob">{{ 'Date of Birth' | translate }} <span class="text-danger">*</span></label>
                      <!-- <input placeholder="mm-dd-yyyy" class="icons__calendar--" id="ba__dob" formControlName="dob"
                        ngbDatepicker appDateRange1900 id="pl__dob" #d="ngbDatepicker" (click)="d.toggle()"  /> -->
                      <input id="pl__confirmdob" placeholder="mm-dd-yyyy" formControlName="dob" datepickerManualAndCalSelection [isDob]="true" />
                      <a class="position-absolute tu__40--px ru__20--px">
                        <svg class="icon__20-- tc__656565--">
                          <use href="../Images/icons__sprite.svg#icon__calendar--o"></use>
                        </svg>
                      </a>
                      @if(hasUserNameAndDob && confirmItsYou.controls.dob.invalid && !isItsNotYou){
                      <small class="text-danger">{{ 'Date of birth is required' | translate }}</small>
                      }
                      @if(isItsNotYou && confirmItsYou.controls.dob.valid){
                      <small class="text-danger">{{ 'Patient credential mismatch.' | translate }}</small>
                      }
                      @if (confirmItsYou.get('dob')?.hasError('directiveError')) {
                      <small class="text-danger">
                        {{ confirmItsYou.get('dob')?.getError('directiveError') | translate }}
                      </small>
                      }
                    </div>
                  </div>
                  
                  <div class="col-12 mt-3">
                    <button type="submit" [disabled]="isItsYouLoading" class="btn__l-- btn__006080--f" 
                      id="pl__continue">{{ 'Continue' | translate }}
                      <!-- <ng-container *ngIf="!isItsYouLoading; else loading">{{ 'Continue' | translate }}</ng-container>
                      <ng-template #loading>
                        <div class="spinner"></div>
                      </ng-template> -->
                    </button>
                  </div>

                  <div class="col-12">
                    <button type="button" (click)="nextTab('backToLogin')" class="btn__l-- btn__006080--o" 
                      id="pl__backtologin">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none"
                        class="me-2">
                        <path d="M11 5L1 5M1 5L5 9M1 5L5 1" stroke="#006080" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                      {{ 'Back to Login' | translate }}
                    </button>
                  </div>

                  <div class="col-12 text-center mt-3">
                    <small class="fw__4-- fs__14-- tc__475467-- lh__20--px">
                      {{ 'Not sure about your username?' | translate }}
                      <a id="pl__contactpractice" href="#" class="fw__4-- fs__14-- tc__006080-- lh__20--px">{{ 'Contact our practice' | translate }}</a>
                      {{ 'for assistance.' | translate }}
                    </small>
                  </div>
                </form>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #existingAccountModal let-modal>
  <div class="modal-body">
    <div class="d-flex flex-column gap-3 p-2">
      <div class="d-flex flex-column align-items-center gap-2">
        <div class="border p-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
              d="M8 13.3307V10.6641C8 6.25073 9.33333 2.66406 16 2.66406C22.6667 2.66406 24 6.25073 24 10.6641V13.3307"
              stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path
              d="M22.668 29.3359H9.33464C4.0013 29.3359 2.66797 28.0026 2.66797 22.6693V20.0026C2.66797 14.6693 4.0013 13.3359 9.33464 13.3359H22.668C28.0013 13.3359 29.3346 14.6693 29.3346 20.0026V22.6693C29.3346 28.0026 28.0013 29.3359 22.668 29.3359Z"
              stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M21.3273 21.3307H21.3393" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path d="M15.9914 21.3307H16.0034" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path d="M10.6593 21.3307H10.6713" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
              stroke-linejoin="round"></path>
          </svg>
        </div>
        <label class="fs__16-- fw__5-- tc__101828-- fs__normal-- text-center">{{ 'Account already exists' | translate }} </label>
      </div>
      <div class="d-flex flex-column gap-2">
        <label class="fs__16-- fw__4-- tc__656565-- text-center fs__normal--">
          {{ 'We found an account linked to' | translate }} <span class="fw__5--">{{selectedPatient.FirstName}}
            {{selectedPatient.LastName}}</span> {{ 'Click Continue to login and proceed.' | translate }}
        </label>
        <button id="pl__continuetologin" class="btn__m-- btn__006080--f" (click)="continueToLogin(modal)">{{ 'Continue to Login' | translate }}</button>
        <a id="pl__confirmitsyou" class="fs__14-- fw__4-- tc__1D5558-- text-end c__p--"
          (click)="moveToConfirmItsYou(modal, selectedPatient)">{{ 'move to confirm its you' | translate }}</a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #multipleExistingAccountModal let-modal>
  <div class="modal-body">
    <div class="d-flex flex-column gap-4 p-2">
      <div class="d-flex flex-column align-items-center gap-2">
        <div class="border p-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
              d="M8 13.3307V10.6641C8 6.25073 9.33333 2.66406 16 2.66406C22.6667 2.66406 24 6.25073 24 10.6641V13.3307"
              stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path
              d="M22.668 29.3359H9.33464C4.0013 29.3359 2.66797 28.0026 2.66797 22.6693V20.0026C2.66797 14.6693 4.0013 13.3359 9.33464 13.3359H22.668C28.0013 13.3359 29.3346 14.6693 29.3346 20.0026V22.6693C29.3346 28.0026 28.0013 29.3359 22.668 29.3359Z"
              stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M21.3273 21.3307H21.3393" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path d="M15.9914 21.3307H16.0034" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path d="M10.6593 21.3307H10.6713" stroke="#1D1D1D" stroke-width="2.66667" stroke-linecap="round"
              stroke-linejoin="round"></path>
          </svg>
        </div>
        <label class="fs__16-- fw__5-- tc__101828-- fs__normal-- text-center">{{ 'Account already exists' | translate }} </label>
      </div>
      <div class="d-flex flex-column gap-3">
        <label class="fs__16-- fw__4-- tc__656565-- fs__normal--">
          {{ 'We found an account linked to {name}. Click Continue to login and proceed.' | translate: { name: (selectedPatient.FirstName || '') + ' ' + (selectedPatient.LastName || '') } }}
        </label>
        <span class="fs__16-- fw__4-- tc__151515-- fs__normal--">{{ 'User Name' | translate }}: {{selectedPatient.EmailId | maskedtext}}</span>
        <button id="pl__multicontinuetologin" class="btn__m-- btn__006080--f" (click)="continueToLogin(modal)">{{ 'Continue to Login' | translate }}</button>
        <button id="pl__choosedifferent" class="btn__m-- btn__006080--o" (click)="choosediffPatient(modal)">{{ 'Choose a different patient' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>
